module.exports = __webpack_public_path__ + "static/img/logo2.1c35fd0e.png";